import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppHeaderComponent } from '../../../shared/core/ui/app-header/app-header.component';
import { AppFooterComponent } from '../../../shared/core/ui/app-footer/app-footer.component';
import { UserContextService } from '../../../common/user-management/auth-management/authentication/services/user-context.service';
import { WalletStateService } from '../../../financial-management/wallets';

@Component({
  selector: 'app-base',
  standalone: true,
  imports: [RouterOutlet, CommonModule, AppHeaderComponent, AppFooterComponent],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent implements OnInit {
  isLoading = true; // Default to true while loading

  private cdr = inject(ChangeDetectorRef);
  private walletState = inject(WalletStateService);

  ngOnInit(): void {
    // Owner of the initial wallet load. The header, the router outlet and the routed page all sit inside the
    // template's bare `@defer` (defaults to `on idle`, and the header/outlet are lazy dependencies), so none of
    // them exist yet; starting here lets the request run while that block resolves. They only read the state.
    if (UserContextService.isAuthenticated()) {
      this.walletState.ensureWalletLoaded();
    }

    // Simulate loading with a timeout
    setTimeout(() => {
      this.isLoading = false;

      // Trigger change detection manually
      this.cdr.detectChanges();
    }, 1000); // Adjust the timeout as needed
  }
}
